/**
 * Step 2's selection state (TO-123 REQ-003): the last saved order and the
 * manager's unsaved edit of it. Pure — the hook wires it to the API.
 */
export interface SelectionState {
	saved: string[]
	draft: string[]
}

export type SelectionAction =
	| { type: 'add'; productId: string }
	| { type: 'moveUp'; productId: string }
	| { type: 'moveDown'; productId: string }
	| { type: 'remove'; productId: string }
	| { type: 'saved'; productIds: string[] }

const swap = (ids: string[], i: number, j: number): string[] => {
	const next = [...ids]
	;[next[i], next[j]] = [next[j] as string, next[i] as string]
	return next
}

export function selectionReducer(state: SelectionState, action: SelectionAction): SelectionState {
	const { draft } = state
	switch (action.type) {
		case 'add':
			return draft.includes(action.productId) ? state : { ...state, draft: [...draft, action.productId] }
		case 'remove':
			return { ...state, draft: draft.filter((id) => id !== action.productId) }
		case 'moveUp': {
			const i = draft.indexOf(action.productId)
			return i > 0 ? { ...state, draft: swap(draft, i, i - 1) } : state
		}
		case 'moveDown': {
			const i = draft.indexOf(action.productId)
			return i >= 0 && i < draft.length - 1 ? { ...state, draft: swap(draft, i, i + 1) } : state
		}
		case 'saved':
			return { saved: [...action.productIds], draft: [...action.productIds] }
	}
}

/** Save is allowed only for a non-empty selection that differs from the saved order. */
export const canSave = ({ saved, draft }: SelectionState): boolean =>
	draft.length > 0 && (draft.length !== saved.length || draft.some((id, i) => id !== saved[i]))
